import { render, staticRenderFns } from "./SelectCopyrightArtist.vue?vue&type=template&id=4a8effc2&"
import script from "./SelectCopyrightArtist.vue?vue&type=script&lang=js&"
export * from "./SelectCopyrightArtist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports